import { ButtonHeading, CommonModal } from 'components'
import BootstrapTable from 'components/BootstrapTable';
import MastersFilterModal from 'modals/MastersFilterModal';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { FaRegTrashCan } from 'react-icons/fa6';
import { FiEdit } from 'react-icons/fi';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { utils } from 'helper';
import { changeUserStatusData } from '_services/userService';
import StorageService from 'utils/StorageServices/StorageServices';
import { changeMaterialStatus, deleteMaterialType, getMateriallist } from 'features';
import { AddMaterialModal, UploadBannerModal } from 'modals';

const MaterialCategory = () => {

  const dispatch = useDispatch();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showMaterialModal, setShowMaterialModal] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  // const [showOffcanvas, setShowOffcanvas] = useState(false);
  // const [editConsignerData, setEditConsignerData] = useState(null)
  // const { data, loading } = useSelector((state) => state?.userData);
  const itemsPerPage = 10;
  // const userList = data?.data?.user_list
  // const totalCount = data?.data?.total_record
  const [materialList, setMaterialList] = useState([]);
  const [filter, setFilter] = useState({
    limit: 10,
    offset: 1,
    search: "",
    status: 1
  });

  // console.log("***********", userList);

  useEffect(() => {
    getMaterial()
  }, [filter])

  let addMaterialModal = {
    isOpen: showMaterialModal,
    closeModal: (e) => setShowMaterialModal(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add Material",
    submitTitle: "Add",
    cancelButtonTitle: "Cancel",
    getMaterial: (e) => getMaterial()
    // getBanner: (e) => getBanner()
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(!isDelete),
    modalMainClass: 'confirmModal_new',
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: ()=>submitDeleteMaterial(),
    // isLoadding: loading,
  }


  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  // const renderPagination = () => {
  //   const totalPages = Math.ceil(totalCount / itemsPerPage);
  //   const currentPage = filter.offset;
  //   let pages = [];
  //   const createPageItem = (i) => (
  //     <li
  //       key={i}
  //       className={`page-item ${i === currentPage ? "active" : ""}`}
  //     >
  //       <a
  //         className="page-link _avPointer"
  //         onClick={() => handlePageChange(i)}
  //       >
  //         {i}
  //       </a>
  //     </li>
  //   );

  //   const rangeStart = Math.max(2, currentPage - 2);
  //   const rangeEnd = Math.min(totalPages - 1, currentPage + 2);


  //   pages.push(createPageItem(1));


  //   if (rangeStart > 2) {
  //     pages.push(
  //       <li key="dots-before" className="page-item disabled">
  //         <span className="page-link">...</span>
  //       </li>
  //     );
  //   }


  //   for (let i = rangeStart; i <= rangeEnd; i++) {
  //     pages.push(createPageItem(i));
  //   }


  //   if (rangeEnd < totalPages - 1) {
  //     pages.push(
  //       <li key="dots-after" className="page-item disabled">
  //         <span className="page-link">...</span>
  //       </li>
  //     );
  //   }


  //   if (totalPages > 1) {
  //     pages.push(createPageItem(totalPages));
  //   }

  //   return (
  //     <ul className="pagination ">
  //       <li className={`page-item ${filter?.offset === 1 ? "disabled" : ""}`}>
  //         <a
  //           className="page-link _avPointer"
  //           onClick={() => handlePageChange(filter?.offset - 1)}
  //         >
  //           <IoChevronBack />
  //         </a>
  //       </li>
  //       {pages}
  //       <li
  //         className={`page-item ${filter?.offset === totalPages ? "disabled" : ""
  //           }`}
  //       >
  //         <a
  //           className="page-link _avPointer"
  //           onClick={() => handlePageChange(filter?.offset + 1)}
  //         >
  //           <IoChevronForward />
  //         </a>
  //       </li>
  //     </ul>
  //   );
  // };

  // const toggleOffcanvas = () => {
  //   setShowOffcanvas(!showOffcanvas);
  //   setEditConsignerData(null)
  // };

  const columns = [
    { header: "", accessor: "serial" },
    { header: "Name", accessor: "name" },
    { header: "Status", accessor: "status" },

  ];

  const handleStatusEvent = async (data) => {
    try {
      const payload = {
        material_type_id: data?._id,
        active: data?.active === 1 ? 0 : 1,
      };

      const res = await changeMaterialStatus(payload);
      if (res?.responseCode === 200) {
        getMaterial();
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const handleDelete = (item) => {
    setIsDelete(item)
  }

  const submitDeleteMaterial = async () => {
    const payload = {
      material_type_id: isDelete?._id
    }
    try {
      const res = await deleteMaterialType(payload);
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage);
        setIsDelete(false);
        getMaterial();
      } else {
        toast.success('Error !! ');
      }
    } catch (error) {
      throw error;
    }
  }



  const rowListData = (data) => {

    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                // to={`/account/supplier/details/${item?._id}`}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>
              <Link

                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <FiEdit />
                  </span>
                  &nbsp; Edit
                </span>
              </Link>

              <div className="_avPointer" onClick={() => handleDelete(item)}>
                <span className="_samAnchor">
                  <span className="deleteIcon_avt">
                    <FaRegTrashCan color="red" />
                  </span>
                  Delete
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),

      // contact_number: (
      //   <React.Fragment>
      //     <Link
      //     // to={}
      //     >
      //       {item?.mobile_no ? item?.mobile_no : "-"}
      //     </Link>
      //   </React.Fragment>
      // ),

      name: (
        <React.Fragment>
          {item?.name ? item?.name : "-"}
        </React.Fragment>
      ),


      status: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <input
            className="form-check-input _pi_ter"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            checked={item?.active === 1 ? true : false}
            onChange={(e) => handleStatusEvent(item)}
          />
          <span className={item?.active === 1 ? "active_label_masters_status" : "disabled_label_masters_status"}>
            {item?.active === 1 ? "Active" : "Disabled"}
          </span>

        </div>
      ),

    }));
  };

  // const commonFetchFuction = async (
  //   apiMethod,
  //   payload = {},
  //   transformer = (res) => res
  // ) => {
  //   try {
  //     const res = await apiMethod(payload);
  //     if (res?.responseCode === 200) {
  //       return transformer(res);
  //     } else {
  //       toast.error(res?.responseMessage);
  //     }
  //   } catch (error) {
  //     toast.error(error?.message || "Something went wrong");
  //   }
  // };

  // const getMaterial = async () => {
  // const payload = {
  //   ...filter,
  //   limit: filter?.limit,
  //   offset: filter?.offset,
  // }

  // try {
  //   const res = await dispatch(
  //     getMateriallist(payload)
  //   );

  //   if (res.payload?.responseCode === 200) {

  //   }
  // } catch (error) {
  //   // throw error;
  // }


  // const res = await dispatch(commonFetchFuction(getComapnyList,payload))

  // }

  const getMaterial = async () => {
    const payload = {
      // banner_id: isDelete?._id
    }
    try {
      const res = await getMateriallist(payload);
      if (res?.responseCode == 200) {
        setMaterialList(res?.data?.material_type)
        // setIsDelete(false);
        // getBanner();
      } else {
        toast.success('Error !! ');
      }
    } catch (error) {
      throw error;
    }
  }







  return (
    <>
      <ButtonHeading
        title={"User"}
        // onClick={toggleOffcanvas}
        onClick={() => setShowMaterialModal(!showMaterialModal)}
        buttonTitle="Add Material"
        showSearchFilter={{ search: true, filterOption: true, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
      />

      <div className='_tabWith_outTab'>
        <BootstrapTable
          columns={columns}
          data={rowListData(materialList?.length > 0 ? materialList : [])}
        // isLoading={loading}
        />

        <div className='paginationFt_avt'>
          {/* {renderPagination()} */}
        </div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>


      {showMaterialModal
        && (
          <AddMaterialModal {...addMaterialModal} />
        )
      }

      <CommonModal {...propsObject}>
        <p className='p-3'> Do you really want to delete this Material ? </p>
      </CommonModal>
    </>
  )
}

export default MaterialCategory